import { useCallback } from "react"
import { v4 as uuidv4 } from 'uuid';

export default function useHelper() {

  const downloadFileFromUrl = useCallback((url: string, type?: string) => {
    download(url, uuidv4())
  }, [])

  const download = useCallback((path: string, filename: string) => {
    const anchor = document.createElement('a');
    anchor.href = path;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }, [])

  const handleFilterArray = useCallback((value, FilterLabel) => {
    const FilterLabelNew: any = FilterLabel;
    const index = FilterLabelNew.indexOf(value);
    if (index > -1) {
      FilterLabelNew.splice(index, 1);
    } else {
      FilterLabelNew.push(value)
    }
    return FilterLabelNew
  }, [])

  return { downloadFileFromUrl, handleFilterArray }
}